import { useRoutes } from '@/shared/routes';

export const orgRoutes = [
  {
    path: useRoutes.ORG_LIST_PATH,
    name: useRoutes.ORG_LIST_NAME,
    component: () => import('@/pages/OrgList'),
  },
  {
    path: useRoutes.ORG_ITEM_PATH,
    name: useRoutes.ORG_ITEM_NAME,
    component: () =>
      import('~packages/epk-org-client').then(i => i.OrgItemPage),
  },
];
